<template>
	<div class="course-detail">
		<!-- 浏览器限制遮罩 -->
		<div v-if="showBrowserBlock" class="browser-block-overlay">
			<div class="browser-block-content">
				<div class="browser-block-icon">⚠️</div>
				<h3>浏览器不支持</h3>
				<p>为了保护视频内容安全，本页面不支持UC浏览器和夸克浏览器访问。</p>
				<p>请使用Chrome、Safari、Firefox或Edge等浏览器访问。</p>
				<button class="browser-block-btn" @click="goBack">返回</button>
			</div>
		</div>
		<div class="cont">
			<div class="main">
				<div :class="isScreen?'iframeContAct':'iframeCont'" v-if="courseDetailList[act]&&courseDetailList[act].qf_url">
					<div class="screen" @click="isScreen=!isScreen">{{isScreen?'窗口':'全屏'}}</div>
					<iframe allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; payment; display-capture; autoplay" :src="courseDetailList[act]&&courseDetailList[act].qf_url+'&user_id='+userInfo.qfUserId+'&token='+userInfo.qfToken" style="border: none;"></iframe>
				</div>
				<div id="mse" v-else></div>
				<!-- <video id="myVideo" v-else :src="courseDetailList[act]&&courseDetailList[act].video_url" controls controlsList="nodownload noremoteplayback" @contextmenu.prevent @dragstart.prevent @selectstart.prevent></video> -->
				<div class="text-cont">
					<div class="title">
						<div>{{courseDetailList[act]&&courseDetailList[act].name}}</div>
						<div class="ruo">{{courseDetailList[act]&&courseDetailList[act].point_name}}</div>
					</div>
					<div class="details">
						<div>老师：{{courseDetailList[act]&&courseDetailList[act].teacher}}</div>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="sub-head">
					<div class="course-title">课程列表</div>
					<button v-if="!showBackgroundImage" class="back-btn" @click="backToPackageSelection">返回课程包</button>
				</div>	
				<div class="course-cont">
					<div class="course-card" @click="checkTi(index)" v-for="(item,index) in courseDetailList" :key="index">
						<div class="course-bg" :style="{backgroundImage:`url(${item.coverImg})`}">
							<div v-if="item.isCompleted" class="course-study">已完成</div>
						</div>
						<div class="course-name">{{item.name}}</div>
						<div class="course-text">{{item.point_info}}</div>
						<div class="course-btn">
							<span class="course-teacher">{{item.teacher}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		/* 底图显示状态 */
		<div v-if="showBackgroundImage && !showPackageModal" class="background-only">
			<div class="background-image"></div>
			<div class="click-hotspot" @click="backToPackageSelection"></div>
			<button class="background-back-btn" @click="goBack">返回</button>
		</div>
		
		/* 课程包选择弹窗 */
		<div v-if="showPackageModal" class="package-modal">
			/* 背景图片层 */
			<div class="modal-background-image"></div>
			<div class="modal-content">
				<div class="modal-header">
					<h3>选择课程包</h3>
					<button class="close-btn" @click="closePackageModal">×</button>
				</div>
				<div class="modal-body">
					<div class="package-list">
						<div class="package-item" v-for="(item, index) in packageList" :key="index" @click="selectPackage(item)">
							<div class="package-name">{{item.pkg_name}}</div>
							<div class="package-code">编号：{{item.code}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-overlay"></div>
		</div>
	</div>
</template>

<script>
import { sha1 } from 'js-sha1'
import Player from 'xgplayer';
import 'xgplayer/dist/index.min.css';
export default {
	name: 'wxCourseDetail',
	components: {},
	data(){
		return {
			userInfo: null,
			courseDetailList: [],
			act: 0,
			isScreen: false,
			showPackageModal: false,
			showBackgroundImage: false, // 新增：控制底图显示
			packageList: [],
			token: null,
			pointCode: null,
			pid: null,
			urlToken: null,
			startTime: null,
			pageStartTime: null,
			recordedTime: 0, // 已记录的时间（秒）
			minCount: 0, // 最小计时限制（分钟）
			maxCount: 0, // 最大计时限制（分钟）
			currentPageTime: 0, // 当前页面计时（秒）
			timeCheckInterval: null, // 计时检查定时器
			player: null, // xgplayer实例
			showBrowserBlock: false // 浏览器限制遮罩显示状态
		}
	},
	created(){
		// 检测浏览器类型
		if (this.checkRestrictedBrowser()) {
			this.showBrowserBlock = true;
			return; // 如果是受限浏览器，不执行后续逻辑
		}
		this.initTokenLogin();
	},
	beforeDestroy() {
		this.getRecordAdd({type: false});//退出页面时上传学习记录
		
		// 清理定时器
		if (this.timeCheckInterval) {
			clearInterval(this.timeCheckInterval);
		}
		
		// 销毁播放器实例
		if (this.player) {
			this.player.destroy();
			this.player = null;
		}
		
		// 记录当前页面计时
		this.recordCurrentPageTime();
	},
	mounted() {
		// 记录进入页面的时间
		this.startTime = new Date();
		this.pageStartTime = new Date();
		
		// 原myVideo相关逻辑（已替换为xgplayer）
		/*
		var video = document.getElementById('myVideo');
		if (video) {
			video.play().catch(error => {
				console.error("自动播放失败:", error);
			});
			// 禁用右键菜单
			video.addEventListener('contextmenu', function(e) {
				e.preventDefault();
				return false;
			});
			// 禁用拖拽
			video.addEventListener('dragstart', function(e) {
				e.preventDefault();
				return false;
			});
			// 禁用选择
			video.addEventListener('selectstart', function(e) {
				e.preventDefault();
				return false;
			});
			// 禁用键盘快捷键下载
			video.addEventListener('keydown', function(e) {
				// 禁用Ctrl+S, Ctrl+A, F12等快捷键
				if (e.ctrlKey && (e.keyCode === 83 || e.keyCode === 65)) {
					e.preventDefault();
					return false;
				}
				if (e.keyCode === 123) { // F12
					e.preventDefault();
					return false;
				}
			});
			// 设置video属性
			video.setAttribute('disablePictureInPicture', 'true');
			video.setAttribute('disableRemotePlayback', 'true');
			
			// 添加视频结束事件监听
			video.addEventListener('ended', () => {
				this.getRecordAdd({type: true});
			});
		}
		*/
	},
	methods: {
		// 检测是否为受限浏览器（UC浏览器和夸克浏览器）
		checkRestrictedBrowser() {
			const userAgent = navigator.userAgent.toLowerCase();
			console.log('userAgent:', userAgent)
			// 检测UC浏览器
			const isUC = userAgent.includes('ucbrowser') || userAgent.includes('uc browser') || userAgent.includes('ucweb') || userAgent.includes('ucpc');
			// 检测夸克浏览器
			const isQuark = userAgent.includes('quark') || userAgent.includes('quarkbrowser');
			
			console.log('User Agent:', userAgent);
			console.log('Is UC Browser:', isUC);
			console.log('Is Quark Browser:', isQuark);
			
			return isUC || isQuark;
		},
		
		// 生成stringA
		generateStringA(userId) {
			const base = userId.toString()
			const pad = '12345678'.slice(0, Math.max(0, 8 - base.length))
			return base + pad
		},
		
		// 生成随机字符串
		generateRandomString(length = 16) {
			const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let result = ''
			for (let i = 0; i < length; i++) {
				result += chars.charAt(Math.floor(Math.random() * chars.length))
			}
			return result
		},
		
		// 生成签名参数
		generateSignParams() {
			const userId = this.userInfo.qfUserId
			const token = this.userInfo.qfToken
			const stringA = this.generateStringA(userId)
			const rand = this.generateRandomString()
			const timestamp = Math.floor(Date.now() / 1000)
			const key = 'read.bluebirdabc.com-web-api'
			const signRaw = stringA + token + stringA + key + rand + timestamp
			const sign = sha1(signRaw)
			
			return {
				rand,
				timestamp,
				sign
			}
		},
		
		// 计算学习时长
		calculateTimeSpent() {
			// 计算停留时间（秒）
			const timeSpent = (new Date() - this.startTime) / 1000;
			console.log(`本次学习时长：${parseInt(timeSpent)} 秒`);
			return parseInt(timeSpent)
		},
		
		// 上传学习记录
		async getRecordAdd(status){
			if (!this.userInfo || !this.courseDetailList[this.act]) {
				return;
			}
			
			let jsondata = {
				pointId: this.pointCode,
				pointName: this.courseDetailList[this.act].name,
				subject: this.userInfo.subject || '',
				level: this.userInfo.level || '',
				type: 1,//课程
				token:this.token,
				reqVo: {
					businessId: this.courseDetailList[this.act].id+'',
					businessName: this.courseDetailList[this.act].name,
					type: 1,
					completeStatus: status.type ? true : false,
					operaLongTime: ""+this.calculateTimeSpent()
				}
			};
			
			try {
				const res = await this.$api.getRecordAdd(jsondata);
				if (res.data.success) {
					if(status.type){
						localStorage.setItem('courseHot',true);
						this.courseDetailList[this.act].isCompleted = true;
					}
					this.$forceUpdate();
					let allCompleted = true;
					this.courseDetailList.forEach((courseItem, index) => {
						if (!courseItem.isCompleted) {
							allCompleted = false;
						}
					});
					
					// 如果所有其他子项的 isCompleted 都为 true，则调用 complete() 方法
					if (allCompleted) {
						this.getLearnComplete();
					}
					this.startTime = new Date();
					console.dir('上传学习记录完成')
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			} catch (error) {
				console.error('上传学习记录失败:', error);
			}
		},
		
		// 学习知识点完结操作
		async getLearnComplete(){
			let jsondata = {
				pointId: this.pointCode,
				subject: this.userInfo.subject || '',
				level: this.userInfo.level || '',
				type: 1,//课程
			};
			
			try {
				const res = await this.$api.getLearnComplete(jsondata);
				if (res.data.success) {
					localStorage.setItem('courseHot',true);
					this.$message.success('该知识点课程已全部完成');
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			} catch (error) {
				console.error('完成学习失败:', error);
			}
		},
		
		// Token免登逻辑
		async initTokenLogin() {
			// 检查URL中的token参数（支持hash模式）
			this.token = this.$route.query.token;
			
			if (!this.token) {
				this.$message.error('缺少token参数');
				return;
			}
			
			try {
				// 使用token接口获取用户信息
				const res = await this.$api.userLoginByToken(this.token);
				
				if (res.data.success) {
					this.userInfo = res.data.data;
					localStorage.setItem("userInfo", JSON.stringify(res.data.data));
					
					// 保存userCode
					if (res.data.data.code) {
						localStorage.setItem("userCode", res.data.data.code);
					}
					
					// 初始化时间设置（只有登录成功后才执行计时逻辑）
					this.initTimeSettings();
					// 检查pointCode
					if (res.data.data.pointCode) {
						this.pointCode = res.data.data.pointCode;
						this.getCourseDetail();
					} else {
						// pointCode为空，显示课程包选择页面
						this.getPackageList();
					}
				} else {
					// token无效
					localStorage.removeItem('userInfo');
					localStorage.removeItem('userCode');
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			} catch (error) {
				console.error('Token登录失败:', error);
				this.$message.error('登录失败');
			}
		},
		
		// 获取课程包列表
		async getPackageList() {
			try {
				const signParams = this.generateSignParams();
				const params = {
					user_id: this.userInfo.qfUserId,
					token: this.userInfo.qfToken,
					rand: signParams.rand,
					timestamp: signParams.timestamp,
					sign: signParams.sign,
					pid: this.userInfo.wxPid || "",
					subject: this.userInfo.isTrial ? -1 : this.userInfo.subject,
					level: this.userInfo.isTrial ? -1 : this.userInfo.level
				};
				console.log(this.userInfo)
				const res = await this.$api.getWanxiao(params);
				
				if (res.data.code === 0) {
					this.packageList = res.data.data;
					this.showBackgroundImage = true; // 显示底图
				} else {
					this.$message.error(res.data.msg || '获取课程包列表失败');
				}
			} catch (error) {
				console.error('获取课程包列表失败:', error);
				this.$message.error('获取课程包列表失败');
			}
		},
		
		// 选择课程包
		async selectPackage(packageItem) {
			try {
				const params = {
					pointCode: packageItem.code,
					pointName: packageItem.pkg_name,
					token: this.token
				};
				
				const res = await this.$api.getWxPointSet(params);
				
				if (res.data.success) {
					// 更新用户信息和userCode
					this.userInfo = res.data.data;
					localStorage.setItem("userInfo", JSON.stringify(res.data.data));
					localStorage.setItem("userCode", res.data.data.code || "");
					
					// 使用返回的pointCode获取课程详情
					this.pointCode = res.data.data.pointCode;
					this.showPackageModal = false;
					this.showBackgroundImage = false; // 选择完成后隐藏底图
					this.getCourseDetail();
				} else {
					this.$message.error(res.data.errMsg || '设置课程包失败');
				}
			} catch (error) {
				console.error('设置课程包失败:', error);
				this.$message.error('设置课程包失败');
			}
		},
		
		// 获取课程详情
		async getCourseDetail() {
			try {
				const signParams = this.generateSignParams();
				const params = {
					user_id: this.userInfo.qfUserId,
					token: this.userInfo.qfToken,
					rand: signParams.rand,
					timestamp: signParams.timestamp,
					sign: signParams.sign,
					pid: this.userInfo.wxPid || "",
					code: this.pointCode
				};
				
				const res = await this.$api.getWanxiaoDetail(params);
				
				if (res.data.code === 0) {
					this.courseDetailList = res.data.data;
					if (this.courseDetailList.length > 0) {
						this.act = 0; // 默认选择第一个课程
						this.initPlayer();
						// 原myVideo播放器初始化代码（已替换为xgplayer）
						/*
						let player = new Player({
							id: 'mse',
							url: this.courseDetailList[this.act].video_url
						});
						*/
					}
				} else {
					this.$message.error(res.data.msg || '获取课程详情失败');
				}
			} catch (error) {
				console.error('获取课程详情失败:', error);
				this.$message.error('获取课程详情失败');
			}
		},
		
		checkTi(index) {
			this.act = index;
			this.getRecordAdd({type: false});//切换课程时上传学习记录
			this.startTime = new Date(); // 重新记录开始时间
			this.initPlayer(); // 重新初始化播放器
		},
		
		// 初始化时间设置
		async initTimeSettings() {
			return;
			console.log('initTimeSettings被调用, token:', this.token);
			if (!this.token) {
				console.log('token不存在，退出初始化');
				return;
			}
			
			try {
				const params = {
					token: this.token
				};
				
				const res = await this.$api.getWxClassTimeSet(params);
				if (res.data.success) {
					this.recordedTime = res.data.data.time;
					this.minCount = res.data.data.minCount;
					this.maxCount = res.data.data.maxCount;
					
					// 开始计时检查
					this.startTimeCheck();
				}
			} catch (error) {
				console.error('获取时间设置失败:', error);
			}
		},
		
		// 开始计时检查
		startTimeCheck() {
			this.timeCheckInterval = setInterval(() => {
				this.currentPageTime = Math.floor((new Date() - this.pageStartTime) / 1000);
				this.checkTimeLimit();
			}, 1000); // 每秒检查一次
		},
		
		// 检查时间限制
		async checkTimeLimit() {
			const totalTimeInSeconds = this.recordedTime + this.currentPageTime;
			const totalTimeInMinutes = totalTimeInSeconds / 60;
			
			console.log(`计时检查: recordedTime=${this.recordedTime}秒, currentPageTime=${this.currentPageTime}秒, totalTime=${totalTimeInSeconds}秒(${totalTimeInMinutes.toFixed(2)}分钟), minCount=${this.minCount}分钟, maxCount=${this.maxCount}分钟`);
			
			// 如果总时间超过minCount，停止计时并记录
			if (this.recordedTime < this.minCount * 60 && totalTimeInMinutes >= this.minCount) {
				console.log('达到minCount限制，记录时间并刷新设置');
				await this.recordCurrentPageTime();
				await this.refreshTimeSettings();
				return;
			}
			
			// 如果总时间超过maxCount，停止计时、记录并刷新页面
			if (this.recordedTime >= this.minCount * 60 && totalTimeInMinutes >= this.maxCount) {
				console.log('达到maxCount限制，记录时间并刷新页面');
				await this.recordCurrentPageTime();
				location.reload();
				return;
			}
		},
		
		// 记录当前页面计时
		async recordCurrentPageTime() {
			if (!this.userInfo || this.currentPageTime === 0) {
				return;
			}
			
			try {
				const params = {
					time: this.currentPageTime,
					token: this.token
				};
				
				await this.$api.addWxClassTime(params);
				console.log(`当前页面计时已记录：${this.currentPageTime}秒`);
			} catch (error) {
				console.error('记录当前页面计时失败:', error);
			}
		},
		
		// 刷新时间设置
		async refreshTimeSettings() {
			return;
			try {
				const params = {
					token: this.token
				};
				
				const res = await this.$api.getWxClassTimeSet(params);
				if (res.data.success) {
					this.recordedTime = res.data.data.time;
					this.minCount = res.data.data.minCount;
					this.maxCount = res.data.data.maxCount;
					
					// 重置当前页面计时
					this.currentPageTime = 0;
					this.pageStartTime = new Date();
				}
			} catch (error) {
				console.error('刷新时间设置失败:', error);
			}
		},
		
		// 关闭课程包选择弹窗
		closePackageModal() {
			this.showPackageModal = false;
		},
		
		// 浏览器后退
		goBack() {
			// 在浏览器限制状态下，直接关闭当前页面或返回上一页
			if (this.showBrowserBlock) {
				// 尝试关闭当前窗口，如果无法关闭则返回上一页
				if (window.opener) {
					window.close();
				} else {
					window.history.back();
				}
			} else {
				window.history.back();
			}
		},
		
		// 初始化播放器
		initPlayer() {
			// 销毁之前的播放器实例
			if (this.player) {
				this.player.destroy();
				this.player = null;
			}
			
			// 创建新的播放器实例
			this.player = new Player({
				id: 'mse',
				url: this.courseDetailList[this.act].video_url,
				autoplay: true,
				pip: false, // 禁用画中画
				download: false, // 禁用下载
				playbackRate: [0.5, 0.75, 1, 1.25, 1.5, 2], // 播放速度选项
				controls: {
					mode: 'normal'
				}
			});
			
			// 添加事件监听
			this.player.on('ready', () => {
				// 播放器准备就绪
				const video = this.player.video;
				if (video) {
					// 禁用右键菜单
					video.addEventListener('contextmenu', function(e) {
						e.preventDefault();
						return false;
					});
					// 禁用拖拽
					video.addEventListener('dragstart', function(e) {
						e.preventDefault();
						return false;
					});
					// 禁用选择
					video.addEventListener('selectstart', function(e) {
						e.preventDefault();
						return false;
					});
					// 禁用键盘快捷键下载
					video.addEventListener('keydown', function(e) {
						// 禁用Ctrl+S, Ctrl+A, F12等快捷键
						if (e.ctrlKey && (e.keyCode === 83 || e.keyCode === 65)) {
							e.preventDefault();
							return false;
						}
						if (e.keyCode === 123) { // F12
							e.preventDefault();
							return false;
						}
					});
					// 设置video属性
					video.setAttribute('disablePictureInPicture', 'true');
					video.setAttribute('disableRemotePlayback', 'true');
					video.setAttribute('controlsList', 'nodownload noremoteplayback');
				}
			});
			
			// 添加视频结束事件监听
			this.player.on('ended', () => {
				this.getRecordAdd({type: true});
			});
			
			// 自动播放
			this.player.on('canplay', () => {
				this.player.play().catch(error => {
					console.error("自动播放失败:", error);
				});
			});
		},
		
		// 返回课程包选择
		backToPackageSelection() {
			// 销毁播放器实例
			if (this.player) {
				this.player.destroy();
				this.player = null;
			}
			this.showBackgroundImage = true;
			this.showPackageModal = true;
			this.courseDetailList = [];
			this.pointCode = null;
			this.getPackageList();
		}
	}
}
</script>

<style scoped>
.course-detail {
	width: 100%;
	height: 100vh;
	background: #f5f5f5;
	overflow: hidden;
}

.cont {
	display: flex;
	height: 100%;
}

.main {
	flex: 1;
	padding: 20px;
	background: white;
	margin-right: 10px;
}

.iframeCont {
	width: 100%;
	height: 400px;
	position: relative;
	border: 1px solid #ddd;
	border-radius: 8px;
	overflow: hidden;
}

.iframeContAct {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 9999;
	background: black;
}

.iframeCont iframe,
.iframeContAct iframe {
	width: 100%;
	height: 100%;
}

.screen {
	position: absolute;
	top: 10px;
	right: 10px;
	background: rgba(0,0,0,0.7);
	color: white;
	padding: 5px 10px;
	border-radius: 4px;
	cursor: pointer;
	z-index: 10;
}

#myVideo,
#mse {
	width: 100%!important;
	height: 78vh!important;
	border-radius: 8px!important;
}

.text-cont {
	margin-top: 20px;
}

.title {
	margin-bottom: 10px;
}

.title > div:first-child {
	font-size: 24px;
	font-weight: bold;
	color: #333;
	margin-bottom: 5px;
}

.ruo {
	font-size: 16px;
	color: #666;
}

.details {
	font-size: 14px;
	color: #888;
}

.right {
	width: 350px;
	background: white;
	padding: 20px;
	border-radius: 8px;
}

.sub-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}

.course-title {
	font-size: 18px;
	font-weight: bold;
	color: #333;
}

.course-cont {
	max-height: calc(100vh - 120px);
	overflow-y: auto;
}

.course-card {
	margin-bottom: 15px;
	padding: 15px;
	border: 1px solid #eee;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.3s;
}

.course-card:hover {
	box-shadow: 0 2px 8px rgba(0,0,0,0.1);
	border-color: #1890ff;
}

.course-bg {
	width: 100%;
	height: 120px;
	background-size: cover;
	background-position: center;
	border-radius: 6px;
	position: relative;
	margin-bottom: 10px;
}

.course-study {
	position: absolute;
	top: 10px;
	right: 10px;
	background: #52c41a;
	color: white;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
}

.course-name {
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin-bottom: 5px;
}

.course-text {
	font-size: 14px;
	color: #666;
	margin-bottom: 10px;
	line-height: 1.4;
}

.course-btn {
	display: flex;
	align-items: center;
}

.course-teacher {
	font-size: 14px;
	color: #888;
}

/* 返回按钮样式 */
.back-btn {
	background: #1890ff;
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
	transition: all 0.3s;
}

.back-btn:hover {
	background: #40a9ff;
}

/* 底图显示状态样式 */
.background-only {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
}

.background-image {
	width: 100%;
	height: 100%;
	background-image: url('../assets/wanxiaobg.jpg');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}

/* 点击热区样式 */
.click-hotspot {
	position: absolute;
	top: 9%;
	right: 6%;
	width: 600px;
	height: 250px;
	cursor: pointer;
	z-index: 10000;
	/* 调试用边框，生产环境可以删除 */
	/* border: 2px dashed rgba(255, 0, 0, 0.5); */
}

/* 背景页面返回按钮样式 */
.background-back-btn {
	position: absolute;
	top: 20px;
	left: 20px;
	background: rgba(0, 0, 0, 0.7);
	color: white;
	border: none;
	padding: 10px 20px;
	border-radius: 6px;
	cursor: pointer;
	font-size: 16px;
	z-index: 10001;
	transition: all 0.3s;
}

.background-back-btn:hover {
	background: rgba(0, 0, 0, 0.9);
}

/* 弹窗样式 */
.package-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* 背景图片层样式 */
.modal-background-image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url('../assets/wanxiaobg.jpg');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	z-index: 10000;
}

.modal-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,0.5);
	z-index: 10001;
}

.modal-content {
	position: relative;
	background: white;
	border-radius: 8px;
	width: 500px;
	max-height: 600px;
	overflow: hidden;
	z-index: 10002;
}

.modal-header {
	padding: 20px;
	border-bottom: 1px solid #eee;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.modal-header h3 {
	margin: 0;
	font-size: 18px;
	color: #333;
}

.close-btn {
	background: none;
	border: none;
	font-size: 24px;
	color: #999;
	cursor: pointer;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	transition: all 0.3s;
}

.close-btn:hover {
	background: #f5f5f5;
	color: #333;
}

.modal-body {
	padding: 20px;
	max-height: 500px;
	overflow-y: auto;
}

.package-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.package-item {
	padding: 15px;
	border: 1px solid #eee;
	border-radius: 6px;
	cursor: pointer;
	transition: all 0.3s;
}

.package-item:hover {
	background: #f0f8ff;
	border-color: #1890ff;
}

.package-name {
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin-bottom: 5px;
}

.package-code {
	font-size: 14px;
	color: #666;
}

/* 浏览器限制遮罩样式 */
.browser-block-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	z-index: 99999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.browser-block-content {
	background: white;
	border-radius: 12px;
	padding: 40px;
	text-align: center;
	max-width: 500px;
	margin: 20px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.browser-block-icon {
	font-size: 48px;
	margin-bottom: 20px;
}

.browser-block-content h3 {
	color: #333;
	font-size: 24px;
	margin-bottom: 20px;
	font-weight: bold;
}

.browser-block-content p {
	color: #666;
	font-size: 16px;
	line-height: 1.6;
	margin-bottom: 15px;
}

.browser-block-btn {
	background: #1890ff;
	color: white;
	border: none;
	padding: 12px 30px;
	border-radius: 6px;
	cursor: pointer;
	font-size: 16px;
	margin-top: 20px;
	transition: all 0.3s;
}

.browser-block-btn:hover {
	background: #40a9ff;
	transform: translateY(-1px);
}
</style>